<template>
  <v-container fluid>
    <v-row>
      <v-col cols="6" class="text-h6 font-weight-bold">স্যালারি ব্যাংক-হিসাবের তথ্য</v-col>
      <v-col cols="6" class="text-end">
        <v-btn color="secondary" size="small" class="me-3 rounded-lg" @click="openModal">
          <v-icon start>mdi-plus-circle-outline</v-icon> যোগ করুন
        </v-btn>
      </v-col>
      <v-col cols="12" md="12">
        <v-table class="language-table">
          <thead>
          <tr>
            <th>ব্যাংকের নাম</th>
            <th>শাখার নাম</th>
            <th>অ্যাকাউন্টের নাম</th>
            <th>অ্যাকাউন্টের নম্বর</th>
            <th>অ্যাকাউন্টের ধরন</th>
            <th>রাউটিং নম্বর</th>
            <th width="120">অ্যাকশন</th>
          </tr>
          </thead>

          <tbody>
          <tr>
            <td colspan="7" class="text-center py-6">
              কোন তথ্য পাওয়া যায়নি
            </td>
          </tr>
          </tbody>
        </v-table>
      </v-col>
    </v-row>


    <form @submit.prevent="submitForm">
      <InsertModal ref="Modal" title="স্যালারি ব্যাংক-হিসাবের তথ্য" :width="800">
        <template #modalBody>
          <v-row>
            <!-- Bank Name -->
            <v-col cols="12" md="6">
              <v-select
                  v-model="form.bank_name"
                  :items="banks"
                  label="ব্যাংকের নাম বাছাই করুন *"
                  variant="outlined"
                  density="comfortable"
                  hide-details="auto"
              />
            </v-col>

            <!-- Branch Name -->
            <v-col cols="12" md="6">
              <v-text-field
                  v-model="form.branch_name"
                  label="শাখার নাম লিখুন *"
                  variant="outlined"
                  density="comfortable"
                  hide-details="auto"
              />
            </v-col>

            <!-- Account Name -->
            <v-col cols="12" md="6">
              <v-text-field
                  v-model="form.account_name"
                  label="অ্যাকাউন্টের নাম লিখুন *"
                  variant="outlined"
                  density="comfortable"
                  hide-details="auto"
              />
            </v-col>

            <!-- Account Number -->
            <v-col cols="12" md="6">
              <v-text-field
                  v-model="form.account_number"
                  label="অ্যাকাউন্টের নম্বর লিখুন *"
                  variant="outlined"
                  density="comfortable"
                  hide-details="auto"
              />
            </v-col>

            <!-- Account Type -->
            <v-col cols="12" md="6">
              <v-select
                  v-model="form.account_type"
                  :items="accountTypes"
                  label="অ্যাকাউন্টের ধরন বাছাই করুন *"
                  variant="outlined"
                  density="comfortable"
                  hide-details="auto"
              />
            </v-col>

            <!-- Routing Number -->
            <v-col cols="12" md="6">
              <v-text-field
                  v-model="form.routing_number"
                  label="রাউটিং নম্বর লিখুন*"
                  variant="outlined"
                  density="comfortable"
                  hide-details="auto"
              />
            </v-col>
          </v-row>
        </template>
        <template #modalFooter>
          <v-row>
            <v-col cols="12">
              <v-btn color="primary" size="large" class="me-3 rounded-lg"  @click="submitForm">
                <v-icon start>mdi-content-save-outline</v-icon>সংরক্ষণ করুন
              </v-btn>
              <v-btn color="grey-darken-1" variant="outlined" size="large" class="rounded-lg" @click="resetForm">
                <v-icon start>mdi-refresh</v-icon>রিসেট
              </v-btn>

            </v-col>
          </v-row>
        </template>
      </InsertModal>
    </form>
  </v-container>
</template>

<script>
import InsertModal from "@/components/shared/InsertModal.vue";

export default {
  name: "LanguageComponent",
  components: {InsertModal},
  data() {
    return {
      form: {
        bank_name: null,
        branch_name: '',
        account_name: '',
        account_number: '',
        account_type: null,
        routing_number: '',
      },
      banks: [
        'Dutch Bangla Bank',
        'BRAC Bank',
        'Islami Bank',
        'Sonali Bank',
      ],

      accountTypes: [
        'Savings',
        'Current',
        'Student',
      ],
      languageData: []
    }
  },
  mounted() {},
  methods: {
    openModal() {
      this.$refs.Modal.openModal()
    },
    editItem(item) {
      console.log("Edit:", item);
    },

    submitForm() {
      console.log(this.form);
    },

    resetForm() {
      this.form = {
        bank_name: null,
        branch_name: '',
        account_name: '',
        account_number: '',
        account_type: null,
        routing_number: '',
      };
    },
  },
};
</script>

<style scoped>

</style>